import { countryBlacklistTerms, linksList } from 'helpers';

import './CountryBlacklist.scss';

const CountryBlacklistRow = () => {

  return (
    <div className="dex-blacklist-row-container">
      <div className="dex-blacklist-row">        
        {_t(countryBlacklistTerms.warningText.defaultTerm, countryBlacklistTerms.warningText.key)}
        <span>
          <a href={linksList.cablesTermsLink} target="_blank">
            {_t(countryBlacklistTerms.linkLabel.defaultTerm, countryBlacklistTerms.linkLabel.key)}
          </a>
        </span>
      </div>
    </div>
  );
};

export default CountryBlacklistRow;